module.exports = __webpack_public_path__ + "img/font-page_1.d752172b.jpg";